import React, { useCallback } from "react"
import { ModalSeeker } from "@ui-seeker/core"
import { TextField, Grid, InputAdornment, IconButton, Tooltip } from "@mui/material"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import { sftpCreatedPassword } from "Pages/Admin/ExportConnections/@signals"

export default function SftpPasswordModal() {
	const onClose = useCallback(() => { sftpCreatedPassword.value = null }, [])

	const onCopy = useCallback(() => {
		navigator.clipboard.writeText(sftpCreatedPassword.value)
	}, [])

	return <ModalSeeker
		title="SFTP User Created"
		isOpen={!!sftpCreatedPassword.value}
		controller={onClose}
		hideActions
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<TextField
					fullWidth
					label="Password"
					value={sftpCreatedPassword.value ?? ""}
					InputProps={{
						readOnly: true,
						endAdornment: <InputAdornment position="end">
							<Tooltip title="Copy">
								<IconButton onClick={onCopy} edge="end">
									<ContentCopyIcon/>
								</IconButton>
							</Tooltip>
						</InputAdornment>,
					}}
				/>
			</Grid>
		</Grid>
	</ModalSeeker>
}